module.exports = __webpack_public_path__ + "static/media/Sage.fba5c3e0.PNG";